var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.001,
    height: 59.001,
    viewBox: "0 0 59.001 59.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secondaryLogo",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M59,29.5A29.5,29.5,0,1,1,29.5,0,29.5,29.5,0,0,1,59,29.5",
    fill: "#fa2539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M68.737,141.853a1.087,1.087,0,0,1-.076.374q-.045.2-.091.4-.091.4-.186.792-.188.791-.392,1.58c-.272,1.049-.57,2.092-.908,3.121s-.716,2.038-1.15,3.027c-.332.756-.7,1.5-1.1,2.218a16.615,16.615,0,0,1-8.913,7.94l-4.162-2.962a25.455,25.455,0,0,0,9.821-6.813c.745-.8,1.455-1.63,2.135-2.485s1.333-1.732,1.965-2.624,1.245-1.8,1.846-2.714q.307-.466.61-.935l.3-.469.151-.235a.756.756,0,0,1,.146-.212",
    transform: "translate(-39.859 -109.238)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M97.294,96a7.239,7.239,0,0,1,2.305-.651q2.991-.788,6.029-1.282A21.554,21.554,0,0,1,113.981,94a5.949,5.949,0,0,1,3.944,2.527c1.1,1.851.829,4.4.11,6.524-1.926,5.686-6.485,9.657-11.2,12.415a28.715,28.715,0,0,0,6.782,3.716q-2.4,3.705-4.968,7.259a49.867,49.867,0,0,1-10.711-7.358L96.552,125.6l-13.69.017a29.786,29.786,0,0,1,2.927-2.708c5.862-5.573,7.558-16.014,10.3-23.759.27-.765.567-2.494,1.089-3.044A.981.981,0,0,1,97.294,96m13.145,8.156c1.285-1.742.189-2.428-1.587-2.527a30.119,30.119,0,0,0-6.581.822c-.856,2.767-1.609,5.6-2.414,8.434,3.656-.672,9-4.564,10.582-6.728",
    transform: "translate(-63.81 -72.091)",
    fill: "#0c0c0c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryLogo);
export default __webpack_public_path__ + "static/media/secondaryLogo.53dc442138eabac356a1086bfc6b39bb.svg";
export { ForwardRef as ReactComponent };